define(["require", "exports", "tslib", "mobx", "../../store/UserStore", "../domain"], function (require, exports, tslib_1, mobx_1, UserStore_1, domain_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FInspApproval = void 0;
    class FInspApproval {
        constructor(insp) {
            Object.defineProperty(this, "insp", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "statusWatcher", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "statusPreWatcher", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApproveDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ""
            });
            Object.defineProperty(this, "IsApproveEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CanUserCaptureApprovalComment", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsRefuseEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefuseDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CancelDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ""
            });
            Object.defineProperty(this, "IsCancelEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ReverseInspCancellationDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ""
            });
            Object.defineProperty(this, "IsReverseCancellationEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.insp = insp;
            this.evaluateStatus();
            this.statusWatcher = (0, mobx_1.observe)(this.insp, "Status", x => {
                this.evaluateStatus();
            });
            this.statusPreWatcher = (0, mobx_1.observe)(this.insp, "StatusPrev", x => {
                this.evaluateStatus();
            });
        }
        evaluateStatus() {
            this.deriveApproveState();
            this.deriveCancelState();
            this.deriveRefuseState();
            this.deriveReverseCancelState();
        }
        get ActiveStatus() {
            if (this.insp.StatusReq && !isNaN(this.insp.StatusReq)) {
                return this.insp.StatusReq;
            }
            else {
                return this.insp.Status;
            }
        }
        get IsPendingReviewOrConfirmed() {
            return this.ActiveStatus == domain_1.FacilityInspStatusDomain.PendingReview || this.ActiveStatus == domain_1.FacilityInspStatusDomain.Confirmed;
        }
        approve() {
            switch (this.insp.Status) {
                case domain_1.FacilityInspStatusDomain.Draft:
                    this.setStatus(domain_1.FacilityInspStatusDomain.Confirmed);
                    break;
                case domain_1.FacilityInspStatusDomain.PendingReview:
                    this.setStatus(domain_1.FacilityInspStatusDomain.Confirmed);
                    break;
                case domain_1.FacilityInspStatusDomain.Confirmed:
                    throw new Error("Can not promote an Inspection that is in a Confirmed state");
                case domain_1.FacilityInspStatusDomain.Cancelled:
                    throw new Error("Can not promote an Inspection that is in a Cancelled state");
                case domain_1.FacilityInspStatusDomain.Refused:
                    throw new Error("Can not promote an Inspection that is in a Refused state");
                default:
                    throw new Error("Unknown Inspection Status");
            }
            this.evaluateStatus();
        }
        refuse() {
            if (this.insp.Status == domain_1.FacilityInspStatusDomain.Draft || this.insp.Status == domain_1.FacilityInspStatusDomain.PendingReview) {
                this.setStatus(domain_1.FacilityInspStatusDomain.Refused);
            }
            else if (this.insp.Status == domain_1.FacilityInspStatusDomain.Cancelled) {
                this.setStatus(domain_1.FacilityInspStatusDomain.Refused);
            }
            else {
                throw new Error(`An Inspection with a status of ${this.insp.Status} can not be refused.`);
            }
            this.evaluateStatus();
        }
        cancel() {
            if (this.insp.Status == domain_1.FacilityInspStatusDomain.Draft || this.insp.Status == domain_1.FacilityInspStatusDomain.PendingReview || this.insp.Status == domain_1.FacilityInspStatusDomain.Confirmed || this.insp.Status == domain_1.FacilityInspStatusDomain.Refused) {
                this.setStatus(domain_1.FacilityInspStatusDomain.Cancelled);
            }
            else {
                throw new Error(`An Inspection with a status of ${this.insp.Status} can not be cancelled.`);
            }
            this.evaluateStatus();
        }
        reverseCancellation() {
            if (this.insp.Status == domain_1.FacilityInspStatusDomain.Cancelled && this.insp.StatusPrev == domain_1.FacilityInspStatusDomain.PendingReview) {
                this.setStatus(domain_1.FacilityInspStatusDomain.PendingReview);
            }
            else if (this.insp.Status == domain_1.FacilityInspStatusDomain.Cancelled && this.insp.StatusPrev == domain_1.FacilityInspStatusDomain.PendingReview) {
                this.setStatus(domain_1.FacilityInspStatusDomain.Confirmed);
            }
            else {
                throw new Error(`An Inspection with a status of ${this.insp.Status} can not be Reverse Cancelled.`);
            }
            this.evaluateStatus();
        }
        deriveApproveState() {
            this.ApproveDesc = "Approve";
            if (this.insp && this.insp.IsUserPriviledgedToEdit) {
                switch (this.insp.Status) {
                    case domain_1.FacilityInspStatusDomain.Draft:
                        if ((0, UserStore_1.isUserStateGovAdminOfficer)()) {
                            this.ApproveDesc = "Approve";
                        }
                        else {
                            this.ApproveDesc = "Request Approval";
                        }
                        this.IsApproveEnabled = true;
                        this.CanUserCaptureApprovalComment = true;
                        break;
                    case domain_1.FacilityInspStatusDomain.PendingReview:
                        this.ApproveDesc = "Approve";
                        this.CanUserCaptureApprovalComment = true;
                        if ((0, UserStore_1.isUserStateGovAdminOfficer)()) {
                            this.IsApproveEnabled = true;
                        }
                        else {
                            this.IsApproveEnabled = false;
                        }
                        break;
                    case domain_1.FacilityInspStatusDomain.Confirmed:
                        this.ApproveDesc = "Confirmed";
                        this.IsApproveEnabled = false;
                        this.CanUserCaptureApprovalComment = true;
                        break;
                    case domain_1.FacilityInspStatusDomain.Cancelled:
                        this.ApproveDesc = "Cancelled";
                        this.IsApproveEnabled = false;
                        this.CanUserCaptureApprovalComment = true;
                        break;
                    case domain_1.FacilityInspStatusDomain.Refused:
                        this.ApproveDesc = "Refused";
                        this.IsApproveEnabled = false;
                        this.CanUserCaptureApprovalComment = true;
                        break;
                    default:
                        throw new Error("Unknown Inspection Status");
                }
            }
            else {
                this.IsApproveEnabled = false;
                this.CanUserCaptureApprovalComment = false;
            }
        }
        deriveRefuseState() {
            this.RefuseDesc = "Refuse";
            if (this.insp && this.insp.IsUserPriviledgedToEdit) {
                switch (this.insp.Status) {
                    case domain_1.FacilityInspStatusDomain.Draft:
                        this.IsRefuseEnabled = false;
                        break;
                    case domain_1.FacilityInspStatusDomain.PendingReview:
                        if ((0, UserStore_1.isUserStateGovAdminOfficer)()) {
                            this.IsRefuseEnabled = true;
                        }
                        else {
                            this.IsRefuseEnabled = false;
                        }
                        break;
                    default:
                        this.IsRefuseEnabled = false;
                }
            }
            else {
                this.IsRefuseEnabled = false;
            }
        }
        deriveCancelState() {
            this.CancelDesc = "Cancel";
            if (this.insp && this.insp.IsUserPriviledgedToEdit) {
                switch (this.insp.Status) {
                    case domain_1.FacilityInspStatusDomain.Draft:
                        this.IsCancelEnabled = true;
                        break;
                    case domain_1.FacilityInspStatusDomain.PendingReview:
                        this.IsCancelEnabled = true;
                        break;
                    case domain_1.FacilityInspStatusDomain.Confirmed:
                        this.IsCancelEnabled = false;
                        break;
                    case domain_1.FacilityInspStatusDomain.Refused:
                        if ((0, UserStore_1.isUserStateGovAdminOfficer)()) {
                            this.IsCancelEnabled = true;
                        }
                        else {
                            this.IsCancelEnabled = false;
                        }
                        break;
                    default:
                        this.IsCancelEnabled = false;
                }
            }
            else {
                this.IsCancelEnabled = false;
            }
        }
        deriveReverseCancelState() {
            this.ReverseInspCancellationDesc = "Reverse Cancellation";
            if (this.insp && this.insp.IsUserPriviledgedToEdit && this.insp.SystemState != domain_1.FacilitySysStatusDomain.Archived) {
                switch (this.insp.Status) {
                    case domain_1.FacilityInspStatusDomain.Cancelled:
                        if (this.insp.StatusPrev == domain_1.FacilityInspStatusDomain.PendingReview || this.insp.StatusPrev == domain_1.FacilityInspStatusDomain.Confirmed) {
                            this.IsReverseCancellationEnabled = true;
                        }
                        else {
                            this.IsReverseCancellationEnabled = false;
                        }
                        break;
                    default:
                        this.IsReverseCancellationEnabled = false;
                }
            }
            else {
                this.IsReverseCancellationEnabled = false;
            }
        }
        restoreToOriginalStatus() {
            this.insp.StatusReq = NaN;
            this.evaluateStatus();
        }
        setStatus(status) {
            this.insp.StatusReq = status;
        }
    }
    exports.FInspApproval = FInspApproval;
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspApproval.prototype, "ApproveDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspApproval.prototype, "IsApproveEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspApproval.prototype, "CanUserCaptureApprovalComment", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspApproval.prototype, "IsRefuseEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspApproval.prototype, "RefuseDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspApproval.prototype, "CancelDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspApproval.prototype, "IsCancelEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspApproval.prototype, "ReverseInspCancellationDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspApproval.prototype, "IsReverseCancellationEnabled", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], FInspApproval.prototype, "ActiveStatus", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FInspApproval.prototype, "restoreToOriginalStatus", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FInspApproval.prototype, "setStatus", null);
});
